var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"ftbd"},[_c('span',[_vm._v("中国法学会  版权所有©2019  京ICP备10012170号  京公网安备110401200001号")]),_c('span',[_vm._v("临时办公地址:北京市海淀区皂君庙4号院  邮编:100081")])])])
}]

export { render, staticRenderFns }